export default __webpack_public_path__ + "static/media/service-family-empty-state-icon.74567a08.svg";